//App.jsx
import React, { useState } from 'react';
import { generateIdeas, generateStepsForIdea } from './api';
import IdeaList from './components/IdeaList';
import jsPDF from 'jspdf';

const App = () => {
  const [promptText, setPromptText] = useState('');
  const [ideas, setIdeas] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleDownloadPDF = async () => {
  const doc = new jsPDF();
  const cleanText = (text) => {
  return text
    .replace(/[^\x20-\x7E]/g, '') // remove non-ASCII
    .replace(/[\u2022\u25CF\u25AA\u2023\u25B6\u25C6]/g, '-') // replace bullets with dash
    .replace(/\s{2,}/g, ' ') // remove excess whitespace
    .trim();
};

  let y = 20;

  doc.setFontSize(16);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(40);
  doc.text('PostSpark – AI-Powered Content Ideas', 105, y, { align: 'center' });

  y += 15;

  ideas.forEach((item, index) => {
    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(0, 0, 0);
    doc.text(`${index + 1}. ${item.idea}`, 10, y);
    y += 10;

    doc.setFontSize(12);
    doc.setFont('helvetica', 'normal');
    doc.text('How to:', 12, y);
    y += 8;

    item.steps.forEach((step) => {
      const cleanStep = cleanText(step);
      const lines = doc.splitTextToSize(`- ${cleanStep}`, 180);
      doc.text(lines, 14, y);
      y += lines.length * 6;
    });


    y += 10;

    if (y > 270) {
      doc.addPage();
      y = 20;
    }
  });

  //Footer: PostSpark credit at bottom only
  doc.setFontSize(10);
  doc.setTextColor(120);
  doc.text('Generated by PostSpark · Made in India 🇮🇳', 10, 290);

  doc.save('content-ideas.pdf');
};

  const handleGenerate = async (e) => {
    e.preventDefault();
    if (!promptText.trim()) return;

    setLoading(true);
    try {
      const rawList = await generateIdeas(promptText);
      const topFiveIdeas = rawList.slice(0, 5);

      const enrichedIdeas = await Promise.all(
        topFiveIdeas.map(async (ideaText) => {
          const steps = await generateStepsForIdea(ideaText);
          return { idea: ideaText, steps };
        })
      );

      setIdeas(enrichedIdeas);
    } catch (err) {
      setIdeas([{ idea: '❌ Error generating ideas.', steps: [] }]);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-r from-gray-900 via-black to-gray-800 text-white flex flex-col justify-between">
      <header className="bg-gray-900 text-white px-6 py-3 shadow-md flex items-center justify-between">
      <div className="flex items-center space-x-3">
        <img src="/logomain.png" alt="PostSpark Logo" className="w-8 h-8" />
        <span className="font-semibold text-lg">PostSpark</span>
      </div>
      <span className="text-sm text-gray-400">AI-Powered Ideas ✨</span>
      </header>

          <main className="flex-grow flex items-center justify-center p-6 relative overflow-hidden">
        {/* Floating Sparkles */}
        <div className="absolute top-0 left-0 w-full h-full pointer-events-none">
          <div className="animate-pulse-slow absolute w-16 h-16 bg-purple-500 rounded-full opacity-30 top-10 left-10 blur-3xl"></div>
          <div className="animate-pulse-slow absolute w-20 h-20 bg-pink-500 rounded-full opacity-20 bottom-10 right-10 blur-3xl"></div>
        </div>

        <div className="bg-gray-800 rounded-2xl shadow-xl p-8 max-w-2xl w-full space-y-6 relative z-10">
          <header className="text-center mb-8">
            <h1 className="text-4xl font-bold text-white mb-2">Content Idea Generator</h1>
            <p className="text-lg text-gray-300">Enter your niche and get content ideas</p>
          </header>

          <form onSubmit={handleGenerate} className="space-y-4">
            <input
              type="text"
              value={promptText}
              onChange={(e) => setPromptText(e.target.value)}
              placeholder="e.g. fitness tips, finance reels, startup memes..."
              className="w-full p-4 rounded-xl bg-gray-900 border border-gray-700 text-white placeholder-gray-400"
            />
            <button
              type="submit"
              className="w-full bg-gradient-to-r from-purple-500 via-pink-500 to-purple-600 
                hover:from-purple-600 hover:to-pink-600 
                text-white py-3 font-semibold rounded-xl shadow-lg shadow-pink-500/30 
                transition duration-300"
              disabled={loading}
            >
              {loading ? 'Generating...' : 'Generate Ideas'}
            </button>
          </form>

          {ideas.length > 0 && (
            <>
              <div className="text-center">
                <button
                  onClick={handleDownloadPDF}
                  className="mt-4 bg-green-600 hover:bg-green-700 text-white py-2 px-4 rounded-xl"
                >
                  Download as PDF
                </button>
              </div>
              <div id="results-section" className="mt-6">
                <IdeaList ideas={ideas} />
              </div>
            </>
          )}
        </div>
      </main>

      <footer
        className="text-sm text-gray-300 font-medium font-sans flex items-center justify-center py-4"
        style={{ fontFamily: `'Segoe UI Emoji', 'Apple Color Emoji', 'Noto Color Emoji', sans-serif` }}
      >
        Powered by AI
      </footer>
    </div>
  );
};

export default App;
